import { MiniNews, MiniNewsResponse } from '@/types/MiniNews'

export function convertMiniNews(data: MiniNewsResponse): MiniNews {
  return {
    text: `${data.module_mini_news.text}`,
    url: `${data.module_mini_news.url}`,
    blank: Boolean(data.module_mini_news.blank)
  }
}
